// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useTranslation } from "react-i18next";
import type { ProductImageFileValidation } from "@/api/hooks/use-product-images";
import { Badge } from "@/components/ui/badge";

const GREEN =
  "bg-green-100 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-900";
const AMBER =
  "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900";
const RED = "bg-red-100 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-300 dark:border-red-900";
const ZINC = "bg-zinc-100 text-zinc-700 border-zinc-200 dark:bg-zinc-900 dark:text-zinc-400 dark:border-zinc-800";

const VALIDATION_COLORS: Record<ProductImageFileValidation, string> = {
  mapped: GREEN,
  duplicate: AMBER,
  not_in_catalog: RED,
  parse_failed: ZINC,
};

/** How a file name resolved against the reference store catalog. */
export function ProductImageValidationBadge({ validation }: { validation: ProductImageFileValidation }) {
  const { t } = useTranslation("back-office");
  return (
    <Badge variant="outline" className={`font-normal text-xs ${VALIDATION_COLORS[validation]}`}>
      {t(`productImages.validation.${validation}`)}
    </Badge>
  );
}
